export const TableOptions = {
    download: false,
    filter: false,
    print: false,
    search: false,
    selectableRows: "none" as any,
    serverSide: true,
    viewColumns: false,
    elevation: 0,
    rowsPerPageOptions: [15, 30, 50],
    setTableProps: () => ({
        size: "small"
    })
};



// WEBPACK FOOTER //
// ./src/inar2/config/Table.ts